import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment-timezone";

/**
 * Generated class for the CurantisDatetimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: "curantisDatetime",
})
export class CurantisDatetimePipe implements PipeTransform {
  /**
   * Takes a datetime and formats it
   */
  transform(value: string, ...args) {
    if (value === null || value === "" || value === undefined) {
      return "";
    }

    let newDate = new Date(value);
    let parsedString = "invalid date";
    // Gets additional options
    if (args.length > 0) {
      for (let i = 0; i < args.length; i++) {
        let option = args[i] ? args[i].toString() : "";
        if (option.toLowerCase() === "dateonly") {
          parsedString = moment(newDate).format("MM/DD/YYYY");
        } else if (option.toLowerCase() === "local") {
          newDate = moment.utc(value).toDate(); //change utc time
          newDate = moment(newDate).local();
          parsedString = moment(newDate).format("MM/DD/YYYY");
        } else if (option.toLowerCase() === "utcdateonly") {
          parsedString = moment(value).format("MM/DD/YYYY");
        } else if (option.toLowerCase() === "localdatetime") {
          newDate = moment.utc(value).toDate(); //change utc time
          newDate = moment(newDate).local();
          parsedString = moment(newDate).format("MM/DD/YYYY HH:mm");
        } else if (option.toLowerCase() === "asutc") {
          parsedString = moment.utc(value).format("MM/DD/YYYY HH:mm");
        } else if (option.toLowerCase() === "asutc-notime") {
          parsedString = moment.utc(value).format("MM/DD/YYYY");
        } else if (option.toLowerCase() === "originaldate") {
          //value has to be in the format of 'YYYY-MM-DD'
          parsedString = moment(value, "YYYY-MM-DD").format("MM/DD/YYYY");
        } else if (option.toLowerCase() === "zoneoffset") {
          let timezoneOffset = args[i + 1]; // get the second param (the offset value)
          parsedString = CurantisDatetimePipe.convertDateUsingOffset(
            value,
            timezoneOffset
          ).format("MM/DD/YYYY HH:mm");
        } else if (option.toLowerCase() === "zoneoffset_dateonly") {
          let timezoneOffset = args[i + 1]; // get the second param (the offset value)
          parsedString = CurantisDatetimePipe.convertDateUsingOffset(
            value,
            timezoneOffset
          ).format("MM/DD/YYYY");
        } else if (option.toLowerCase() === "zoneoffset_dateonly_patch") {
          let timezoneOffset = args[i + 1]; // get the second param (the offset value)
          let admitDischargeDatetime = args[i + 2]; // get the third param (admit or discharge datetime value)
          parsedString =
            admitDischargeDatetime != "" &&
            admitDischargeDatetime == value.toString()
              ? moment(newDate).format("MM/DD/YYYY")
              : CurantisDatetimePipe.convertDateUsingOffset(
                  value,
                  timezoneOffset
                ).format("MM/DD/YYYY");
        } else if (option.toLowerCase() === "local-org-timezone") {
          // works only with "2023-11-01T02:15:52Z" (...Z) - not plain UTC
          let orgTimezone = window.localStorage.getItem("orgTimezone")
            ? window.localStorage.getItem("orgTimezone")
            : moment.tz.guess();
          let tempDate = moment(value);
          parsedString = tempDate.tz(orgTimezone).format("MM/DD/YYYY");
        } else if (
          option.toLowerCase() === "date-with-days-since" ||
          option.toLowerCase() === "local-date-with-days-since"
        ) {
          newDate = moment(newDate);
          if (option.toLowerCase() === "local-date-with-days-since") {
            newDate = moment.utc(value).toDate(); //change utc time
            newDate = moment(newDate).local();
          }
          const timeSinceGivenDate = Math.abs(
            Date.now() - new Date(newDate).getTime()
          );
          let daysSince = Math.floor(
            timeSinceGivenDate / (1000 * 3600 * 24)
          ).toString();
          parsedString =
            moment(newDate).format("MM/DD/YYYY") + " (" + daysSince + " days)";
        } else {
          //DO Nothing
        }
      }
    } else {
      parsedString = moment(newDate).format("MM/DD/YYYY HH:mm");
    }

    if (parsedString.toLowerCase() !== "invalid date") {
      return parsedString;
    }
    return "";
  }

  static convertUTCDateToLocalDate(date: Date) {
    let newDate = new Date(
      date.getTime() + date.getTimezoneOffset() * 60 * 1000
    );

    let offset = date.getTimezoneOffset() / 60;
    let hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
  }

  // converts to timezone based on the offset passed in the second param
  static convertDateUsingOffset(datetime: string, timezoneOffset: number) {
    let convertedDatetime;
    if (timezoneOffset) {
      let utcDatetime = moment.utc(datetime);
      convertedDatetime = utcDatetime.utcOffset(timezoneOffset / 60);
    } else {
      // this means the second parameter (the timezone offset) was not passed or is not valid
      // so as a fallback let's simply convert to the user's local TZ
      convertedDatetime = moment.utc(datetime).toDate(); // set as utc time
      convertedDatetime = moment(convertedDatetime).local(); // convert to local
    }
    return convertedDatetime;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/curantis-datetime.ts